import moment from 'moment';

export const utcFromZonedTime = (date: Date, timeZone?: string, timeZoneOffset?: number): Date => {
  const zonedTime = new Date(date.toLocaleString('en-US', { timeZone })).getTime();
  const timeOffset = timeZone
    ? (date.getTime() - zonedTime)
    : timeZoneOffset * 60 * 1000; // minutes to milliseconds

  return new Date(date.getTime() + timeOffset);
};

export const utcToZonedTime = (date: Date, timeZone?: string, timeZoneOffset?: number): Date => {
  const zonedTime = new Date(date.toLocaleString('en-US', { timeZone })).getTime();
  const timeOffset = timeZone
    ? (date.getTime() - zonedTime)
    : timeZoneOffset * 60 * 1000; // minutes to milliseconds

  return new Date(date.getTime() - timeOffset);
};

export const unixToDateTimeString = (unixTime: number | string, format = 'DD.MM.YYYY HH:mm:ss'): string => {
  return moment.unix(unixTime as number).format(format);
};

export const unixToDateString = (unixTime: number | string, format = 'YYYY-MM-DD'): string => {
  return moment.unix(unixTime as number).format(format);
};

export const dateTimeStringToUnix = (string: string, format = 'DD.MM.YYYY HH:mm:ss'): number => {
  return moment(string, format).valueOf();
};

export const isToday = (date: Date): boolean => {
  const today = new Date();
  if (
    today.getFullYear() === date.getFullYear()
    && today.getMonth() === date.getMonth()
    && today.getDate() === date.getDate()
  ) {
    return true;
  }

  return false;
};

/** Дата N лет назад (напр., нижняя граница для дат рождения: yearsAgo(100)). */
export const yearsAgo = (years: number): Date => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - years);
  return date;
};
